import { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { getLabConfig, getCategories } from '../../utils/api';

import CategoryMenuClasses from '../Categories/CategoryMenu.module.css';

const CustomHome = () => {
	const navigate = useNavigate();

    return (
		<div className={CategoryMenuClasses.mainContainer}>
			<h3 className="heading">How It Works</h3>
			<div className={CategoryMenuClasses.imageRow}>
				<div className={CategoryMenuClasses.imageWrapper}>
					<span className={CategoryMenuClasses.circleNumber}>1</span>
					<h2> Order Your Test Online - No Doctor Visit needed.<br/></h2>
					<p> Create an account in the shop.drugtestingassociates.com portal, shop for tests, and schedule your collection site visit - all with the same session.</p>
					<div className={CategoryMenuClasses.imageContainer}>
						<img src='../images/CTS/Step 1.png' alt='Step 1' className={CategoryMenuClasses.image} />
					</div>
				</div>
				<div className={CategoryMenuClasses.imageWrapper}>
					<span className={CategoryMenuClasses.circleNumber}>2</span>
					<h2> Go to a Nearby Collection Site<br/></h2>
					<p> Choose from over 4,000 trusted collection locations nationwide.  Many sites open as early as 7 AM and offer extended hours, making it easy to book an appointment.</p>
					<div className={CategoryMenuClasses.imageContainer}>
						<img src='../images/CTS/Step 2.jpg' alt='Step 2' className={CategoryMenuClasses.image} /> 
					</div>
				</div>
				<div className={CategoryMenuClasses.imageWrapper}>
					<span className={CategoryMenuClasses.circleNumber}>3</span>
					<h2> Get Your Results Back in a Few Days<br/></h2>
					<p> Get your results in just a few days through the portal.  Easily track your progress with access to both current and past results.</p>
					<div className={CategoryMenuClasses.imageContainer}>
						<img src='../images/CTS/Step 3.png' alt='Step 3' className={CategoryMenuClasses.image} />
					</div>
				</div>
			</div>
		</div>
    );
};

export default CustomHome;